import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/google-business-messaging.vue
var o = {
	name: "DtIconGoogleBusinessMessaging",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--google-business-messaging"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Google Business Messaging",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			d: "M20.331 7.245A6.191 6.191 0 0 0 14.312 2.5H7.939a6.187 6.187 0 0 0-4.252 10.683z",
			fill: "#86a9ff"
		}, null, -1),
		r("path", {
			d: "M3.686 13.182A6.114 6.114 0 0 0 5.29 16.01l6.369 6.369a.42.42 0 0 0 .717-.298v-4.205h3.688a6.187 6.187 0 0 0 6.186-6.294 6.106 6.106 0 0 0-1.919-4.337z",
			fill: "#578cff"
		}, null, -1),
		r("path", {
			d: "M14.313 14.875a6.187 6.187 0 0 0 6.018-7.63 6.337 6.337 0 0 0-4.37-1.745H9.687A6.187 6.187 0 0 0 3.5 11.688a6.1 6.1 0 0 0 .186 1.494 6.167 6.167 0 0 0 4.251 1.693z",
			fill: "#0057cc"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=google-business-messaging.js.map